<template>
  <div class="homePage">
    <div class="section1_swiper" style="background: #131313">
      <swiper ref="mySwiper" key="mySwiper" :options="swiperOptions">
        <swiper-slide>
          <div class="videoCon">
            <video
              ref="videoPlayer"
              class="ship"
              :style="{ width: '100%', height: 'auto' }"
              muted
              autoplay
              loop
            >
              <source
                src="https://wanglian-video.ks3-cn-beijing.ksyuncs.com/video/3d14e7c593a24ca1808999dc03ce3630/new16.mp4"
                type="video/mp4"
              />
            </video>
<!--            <div class="textCon">-->
<!--              <div class="img-con-x-first wow animate__animated durationTime animate__fadeInUp">-->
<!--                <img-->
<!--                  class="img-con-x-first-x"-->
<!--                  src="@/assets/image/index/bannerX.png"-->
<!--                />-->
<!--                <div class="">计划</div>-->
<!--              </div>-->
<!--              <div class="img-con-x-second  wow animate__animated durationTime animate__fadeInUp">-->
<!--                <div class="wow animate__animated durationTime animate__fadeInUp">十周年给您X倍回报</div>-->
<!--              </div>-->
<!--              <div class="img-con-x-third wow animate__animated durationTime animate__fadeInUp">-->
<!--                <router-link class="img-con-x-third-text" to="/xplan">-->
<!--                  <div style="display: flex;align-items: center;">-->
<!--                    <div style="margin-right: 0.14rem">了解更多</div>-->
<!--                    <div>>></div>-->
<!--                  </div>-->
<!--                </router-link>-->
<!--              </div>-->
<!--&lt;!&ndash;              <div class="focusUs wow animate__animated durationTime animate__fadeInUp">&ndash;&gt;-->
<!--&lt;!&ndash;                关注我们&ndash;&gt;-->
<!--&lt;!&ndash;                <img src="@/assets/image/index/pathIcon.png" />&ndash;&gt;-->
<!--&lt;!&ndash;              </div>&ndash;&gt;-->
<!--            </div>-->
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="chartIframe">
            <iframe
              :src="externalURL"
              style="border: none; width: 100%; height: 100%;"
            ></iframe>
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
      <div class="circle-foot"></div>
    </div>

    <div class="item item-about">
      <div class="item-about-con">
        <div class="item-about-con-title-en wow">About us</div>
        <div class="item-about-con-title-zh wow animate__animated durationTime animate__fadeInUp">关于我们</div>
        <div class="item-about-con-desc wow animate__animated durationTime animate__fadeInUp">
          柠檬网联是中国数智园区、无线网络解决方案提供商及运营服务商，公司成立于2014年，10余年深耕无线网络领域。公司先后获得腾讯、广发信德、招商银科、分享投资、中风投等国内知名机构的投资，于2016年新三板挂牌-柠檬网联（835924）。
        </div>
        <div class="item-about-con-desc wow animate__animated durationTime animate__fadeInUp" style="margin-top: 0.4rem">
          “X计划”是柠檬网联10周年推出的重磅之作，专注校园场景，定制打造硬件系统平台一体化的无线网络解决方案，追求应用创新和超高性价比。
        </div>
        <div style="display: flex;margin-top: 0.8rem;">
          <div class="item-about-con-desc-num">
            <div class="item-about-con-desc-num-item">
              <div class="item-about-con-desc-num-item-title wow animate__animated durationTime animate__fadeInUp">
                服务B端客户
              </div>
              <div class="item-about-con-desc-num-item-data">
                <div class="item-about-con-desc-num-item-data-num">
                  <count-to
                    separator=""
                    :startVal="0"
                    :endVal="2000"
                    :duration="2000"
                    ref="count1"
                  ></count-to>
                </div>
                <div class="item-about-con-desc-num-item-data-icon wow animate__animated durationTime animate__fadeInUp">
                  +
                </div>
              </div>
            </div>
          </div>
          <div class="item-about-con-desc-num">
            <div class="item-about-con-desc-num-item">
              <div class="item-about-con-desc-num-item-title wow animate__animated durationTime animate__fadeInUp">
                联网终端数
              </div>
              <div class="item-about-con-desc-num-item-data">
                <div class="item-about-con-desc-num-item-data-num">
                  <count-to
                    separator=""
                    :startVal="0"
                    :endVal="7000"
                    :duration="2000"
                    ref="count2"
                  ></count-to>
                </div>
                <div class="item-about-con-desc-num-item-data-icon wow animate__animated durationTime animate__fadeInUp">
                  万
                </div>
              </div>
            </div>
          </div>
          <div class="item-about-con-desc-num">
            <div class="item-about-con-desc-num-item">
              <div class="item-about-con-desc-num-item-title wow animate__animated durationTime animate__fadeInUp">
                覆盖城市
              </div>
              <div class="item-about-con-desc-num-item-data">
                <div class="item-about-con-desc-num-item-data-num">
                  <count-to
                    separator=""
                    :startVal="0"
                    :endVal="200"
                    :duration="2000"
                    ref="count3"
                  ></count-to>
                </div>
                <div class="item-about-con-desc-num-item-data-icon wow animate__animated durationTime animate__fadeInUp">
                  +
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="item-about-con-sol wow animate__animated durationTime animate__fadeInUp">
          中国数智园区、无线网络解决方案提供商及运营服务商为超 2000家客户提供网络解决方案
        </div>
        <router-link to="/about" class="item-about-con-more wow animate__animated durationTime animate__fadeInUp">
          <div style="display: flex;align-items: center;">
            <div style="margin-right: 0.14rem">了解更多</div>
            <div>>></div>
          </div>
        </router-link>
      </div>
    </div>

    <div class="item-box1 item">
      <div class="img-con">
        <div class="img-con-x-first wow animate__animated durationTime animate__fadeInUp">
          <img
            class="img-con-x-first-x"
            src="@/assets/image/index/bannerX.png"
            style=" width: 0.99rem;height: 1.54rem;margin-right: 0.2rem;vertical-align: center;"
          />
          <div class="">计划</div>
        </div>
        <div class="img-con-x-second wow animate__animated durationTime animate__fadeInUp">
          <div>十周年给您X倍回报</div>
        </div>
        <router-link to="/xplan" class="img-con-x-third wow animate__animated durationTime animate__fadeInUp">
          <div class="img-con-x-third-text">
            <div style="display: flex;align-items: center;">
              <div style="margin-right: 0.14rem">了解更多</div>
              <div>>></div>
            </div>
          </div>
        </router-link>
        <div class="img-con-x-fourth wow animate__animated durationTime animate__fadeInUp">
          <div style="margin-right: 0.4rem">省心省力省时放心</div>
          <div>同行业较高性价比</div>
        </div>
      </div>
    </div>

    <div class="item-solution">
      <div class="solutionBrief">
        <div class="item-solution-first-title">Solution</div>
        <div class="item-solution-second-title wow animate__animated durationTime animate__fadeInUp">解决方案</div>
        <div class="item-solution-desc wow animate__animated durationTime animate__fadeInUp">
          柠檬网联多年来注重无线网络领域，紧随高质量发展的推进步伐，打破关键核心技术壁垒；并基于自身产品独特优势，不断丰富全场景解决方案，赋能全球多个市场千行百业终端应用实例。
        </div>
        <router-link to="/solution" class="item-solution-more wow animate__animated durationTime animate__fadeInUp"> <div style="display: flex;align-items: center;">
          <div style="margin-right: 0.14rem">了解更多</div>
          <div>>></div>
        </div></router-link>
      </div>
      <div class="solutionList">
        <div :class="['solutionItem', getAnimationClass(solutindex1)]">
          <div class="info">
            <div class="title">无线网络</div>
            <div class="areablock">
              <div>高校校园</div>
              <div>中职校园</div>
              <div>工厂无线网络</div>
              <div>工地无线网络</div>
            </div>
          </div>
        </div>
        <div :class="['solutionItem', getAnimationClass(solutindex2)]">
          <div class="info">
            <div class="title">智慧校园</div>
            <div class="areablock">
              <div>校园一卡通解决方案</div>
            </div>
          </div>
        </div>
        <div :class="['solutionItem', getAnimationClass(solutindex3)]">
          <div class="info">
            <div class="title">智慧园区</div>
            <div class="areablock">
              <div>智慧园区</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="item item-product">
      <div class="item-product-title">
        <div class="item-product-first-title">
          Main product introduction
        </div>
        <div class="item-product-second-title wow animate__animated durationTime animate__fadeInUp">主要产品介绍</div>
      </div>
      <div class="item-product-con-first-line">
        <div class="item-product-first-device wow animate__animated durationTime animate__fadeInUp">
          <div class="item-product-first-device-title">网关</div>
          <ul>
            <li>出口设备</li>
            <li>代拨网关设备</li>
          </ul>
          <img
            class="item-product-first-detail-img"
            src="@/assets/image/index/index-product-detail.png"
          />
          <img
            class="item-product-first-device-img"
            src="@/assets/image/index/index-product-gw.png"
            style=" width: 3.54rem; height: 0.85rem; right: 0.41rem;bottom: 0.52rem;"
          />
          <div></div>
        </div>
        <div class="item-product-first-device wow animate__animated durationTime animate__fadeInUp">
          <div class="item-product-first-device-title">交换机</div>
          <ul>
            <li>二层交换机</li>
            <li>三层交换机</li>
            <li>POE交换机</li>
          </ul>
          <img
            class="item-product-first-detail-img"
            src="@/assets/image/index/index-product-detail.png"
          />
          <img
            class="item-product-first-device-img"
            src="@/assets/image/index/index-product-sw.png"
            style="width: 3.27rem;height: 3.27rem;top:0.77rem;right: 0.19rem"
          />
        </div>
        <div class="item-product-first-device wow animate__animated durationTime animate__fadeInUp">
          <div class="item-product-first-device-title">AP</div>
          <ul>
            <li>面板AP</li>
            <li>吸顶AP</li>
            <li>光接入设备</li>
            <li>光网面板AP</li>
          </ul>
          <img
            class="item-product-first-detail-img"
            src="@/assets/image/index/index-product-detail.png"
          />
          <img
            class="item-product-first-device-img"
            src="@/assets/image/index/index-product-ap.png"
            style="width: 1.53rem;height: 1.53rem;bottom:0.23rem;right: 0.45rem"
          />
        </div>
      </div>
      <div style="margin-bottom: 0.2rem"></div>
      <div class="item-product-con-first-line">
        <div class="item-product-first-device item-product-three-device wow animate__animated durationTime animate__fadeInUp">
          <div class="item-product-first-device-title">光网</div>
                    <ul>
                      <li>OLT</li>
                      <li>分光供电一体机</li>
                      <li>光接入设备</li>
                      <li>光网面板AP</li>
                    </ul>
          <img
            class="item-product-first-detail-img"
            src="@/assets/image/index/index-product-detail.png"
          />
                    <img
                      class="item-product-first-device-img"
                      src="@/assets/image/index/index-product-guangwang.png"
                      style="width:2.81rem;height: 0.3516rem;bottom:0.8rem;right: 0.79rem"
                    />
          <div></div>
        </div>
        <div class="item-product-first-device item-product-three-device wow animate__animated durationTime animate__fadeInUp">
          <div class="item-product-first-device-title">运营管理</div>
          <ul>
            <li>认证计费系统</li>
            <li>网管系统</li>
          </ul>
          <img
            class="item-product-first-detail-img"
            src="@/assets/image/index/index-product-detail.png"
          />
          <img
            class="item-product-first-device-img"
            src="@/assets/image/index/product-operation.png"
            style="width: 1.95rem;height:1.73rem;bottom:0.41rem;right:0.8rem"
          />
        </div>
        <div class="item-product-first-device item-product-three-device  wow animate__animated durationTime animate__fadeInUp">
          <div class="item-product-first-device-title">高阶辅助</div>
          <div class="item-product-three-device-item" style="display: flex">
            <ul style="margin-right: 0.54rem">
              <li>运营中台</li>
              <li>客服系统</li>
              <li>CRM系统</li>
              <li>上网管控</li>
            </ul>
            <ul>
              <li>运维工单</li>
              <li>审计系统</li>
              <li>进销存系统</li>
            </ul>
          </div>

          <img
            class="item-product-first-detail-img"
            src="@/assets/image/index/index-product-detail.png"
          />
          <img
            class="item-product-first-device-img"
            src="@/assets/image/index/index-product-platform.png"
            style="width: 2.06rem;height: 1.19rem;bottom:0.61rem;right: 0.80rem"
          />
        </div>
      </div>
<!--      <div class="item-product-con-second-line">-->
<!--        <div class="item-product-second-device wow animate__animated durationTime animate__fadeInUp">-->
<!--          <div class="item-product-second-device-title">光网</div>-->
<!--          <ul>-->
<!--            <li>OLT</li>-->
<!--            <li>分光供电一体机</li>-->
<!--            <li>光接入设备</li>-->
<!--            <li>光网面板AP</li>-->
<!--          </ul>-->
<!--          <img-->
<!--            class="item-product-second-detail-img"-->
<!--            src="@/assets/image/index/index-product-detail.png"-->
<!--          />-->
<!--          <img-->
<!--            class="item-product-first-device-img"-->
<!--            src="@/assets/image/index/index-product-guangwang.png"-->
<!--            style="width:2.73rem;height: 0.5rem;bottom:0.8rem;right: 0.17rem"-->
<!--          />-->
<!--        </div>-->
<!--        <div class="item-product-second-device wow animate__animated durationTime animate__fadeInUp">-->
<!--          <div class="item-product-second-device-title">审计服务器</div>-->
<!--          <ul>-->
<!--            <li>LN-LOG110</li>-->
<!--          </ul>-->
<!--          <img-->
<!--            class="item-product-second-detail-img"-->
<!--            src="@/assets/image/index/index-product-detail.png"-->
<!--          />-->
<!--          <img-->
<!--            class="item-product-first-device-img"-->
<!--            src="@/assets/image/index/index-product-sj.png"-->
<!--            style="width:2.52rem;height: 0.7rem;bottom:0.8rem;right: 0.37rem"-->
<!--          />-->
<!--        </div>-->
<!--        <div class="item-product-second-device wow animate__animated durationTime animate__fadeInUp">-->
<!--          <div class="item-product-second-device-title">系统</div>-->
<!--          <ul>-->

<!--          </ul>-->
<!--          <img-->
<!--            class="item-product-second-detail-img"-->
<!--            src="@/assets/image/index/index-product-detail.png"-->
<!--          />-->
<!--          <img-->
<!--            class="item-product-first-device-img"-->
<!--            src="@/assets/image/index/index-product-system.png"-->
<!--            style="width:2.04rem;height: 1.83rem;bottom:0.49rem;right: 0.61rem"-->
<!--          />-->
<!--        </div>-->
<!--        <div class="item-product-second-device wow animate__animated durationTime animate__fadeInUp">-->
<!--          <div class="item-product-second-device-title">平台</div>-->
<!--          <ul>-->

<!--          </ul>-->
<!--          <img-->
<!--            class="item-product-second-detail-img"-->
<!--            src="@/assets/image/index/index-product-detail.png"-->
<!--          />-->
<!--          <img-->
<!--            class="item-product-first-device-img"-->
<!--            src="@/assets/image/index/index-product-platform.png"-->
<!--            style="width:2.83rem;height: 1.71rem;bottom:0.49rem;right: 0.16rem"-->
<!--          />-->
<!--        </div>-->
<!--      </div>-->
    </div>

    <div class="item-partner">
      <!--    <div class="item-partner-first-title">Collaboration case series</div>-->
      <div class="item-partner-second-title wow animate__animated durationTime animate__fadeInUp">优秀客户合作案例</div>
      <div class="item-partner-num">
        <div class="item-partner-num-data">
          <count-to
            separator=""
            :startVal="0"
            :endVal="2000"
            :duration="2000"
            ref="count4"
          ></count-to>
        </div>
        <div class="item-partner-num-icon wow animate__animated durationTime animate__fadeInUp">+</div>
      </div>
      <div class="item-partner-sou wow animate__animated durationTime animate__fadeInUp">
        提供网络解决方案
      </div>
      <div class="item-partner-desc wow animate__animated durationTime animate__fadeInUp">
        是富士康、比亚迪、立讯、昌硕等知名客户优选的⽆线⽹络解决⽅案提供商及运营服务商。
        为广西工业技师学院
        、肇庆工贸学校等职教校园场景，定制打造硬件系统平台⼀体化的⽆线⽹络解决⽅案。
      </div>
      <router-link to="/partner" class="item-partner-more wow animate__animated durationTime animate__fadeInUp">
        <div style="display: flex;align-items: center;">
          <div style="margin-right: 0.14rem">了解更多</div>
          <div>>></div>
        </div>
      </router-link>
    </div>

    <div class="item item-news">
      <div class="item-news-title">
        <div class="item-news-first-title">NEWS</div>
        <div class="item-news-second-title wow animate__animated durationTime animate__fadeInUp">新闻动态</div>
      </div>
      <div class="item-news-box">
        <div style="display:flex;">
          <div class="item-news-box-left wow animate__animated durationTime animate__fadeInUp cus-pointer">
            <swiper ref="mySwiper2" key="mySwiper2" :options="swiperOptions2">
              <swiper-slide v-for="(item,index) in newsSlide" :key="index" >
                <img @click="newsDetail(item.id)"
                  :src="require(`@/assets/${item.imageSrc}`)"
                  style="width: 7.12rem;height: 3.65rem;vertical-align: bottom;"
                />
                <div
                  style="padding: 0.2rem 0.4rem;background: rgba(112,112,112,0.3);"
                  @click="newsDetail(item.id)"
                >
                  <div class="item-news-box-title " style="height: 0.56rem">
                    {{item.title}}
                  </div>
                  <div class="item-news-box-content brief">
                  {{item.brief}}
                  </div>
                  <div class="item-news-box-date">{{item.time}}</div>
                </div>
              </swiper-slide>
              <div class="swiper-pagination2" slot="pagination"></div>
            </swiper>
          </div>
          <div>
            <div class="item-news-box-right-news-item  wow animate__animated durationTime animate__fadeInUp cus-pointer"   @click="newsDetail(newsList1.id)">
              <img
                :src="require(`@/assets/${newsList1.imageSrc}`)"
                style="width: 2.01rem;height: 1.38rem;margin-right: 0.4rem"
              />
              <div>
                <!--这里rem设置成和UI一样会换行-->
                <div class="item-news-box-title" style="width: 5rem;margin: 0">
                  {{newsList1.title}}
                </div>
                <div class="item-news-box-date" style="">{{newsList1.time}}</div>
                <div class="item-news-box-content brief" style="width: 6rem;">
                  {{newsList1.brief}}
                </div>
              </div>
            </div>
            <el-divider></el-divider>
            <div class="item-news-box-right-news-item  wow animate__animated durationTime animate__fadeInUp cus-pointer"  @click="newsDetail(newsList2.id)">
              <img
                :src="require(`@/assets/${newsList2.imageSrc}`)"
                style="width: 2.01rem;height: 1.38rem;margin-right: 0.4rem"
              />
              <div>
                <!--这里rem设置成和UI一样会换行-->
                <div class="item-news-box-title" style="width: 5rem;margin: 0">
                  {{newsList2.title}}
                </div>
                <div class="item-news-box-date" style="">{{newsList2.time}}</div>
                <div class="item-news-box-content brief" style="width: 6rem;">
                  {{newsList2.brief}}
                </div>
              </div>
            </div>
            <el-divider></el-divider>
            <div class="item-news-box-right-news-item  wow animate__animated durationTime animate__fadeInUp cus-pointer"  @click="newsDetail(newsList3.id)">
              <img
                :src="require(`@/assets/${newsList3.imageSrc}`)"
                style="width: 2.01rem;height: 1.38rem;margin-right: 0.4rem"
              />
              <div>
                <!--这里rem设置成和UI一样会换行-->
                <div class="item-news-box-title" style="width: 5rem;margin: 0">
                  {{newsList3.title}}
                </div>
                <div class="item-news-box-date" style="">{{newsList3.time}}</div>
                <div class="item-news-box-content brief" style="width: 6rem;">
                  {{newsList3.brief}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.min.css";
  import countTo from "vue-count-to";
import newsData from "../news/newsData";
import { WOW } from "wowjs";
import {getRequest} from "../../util/http";

let timer = null;
export default {
  name: "index",
  components: {
    swiper,
    swiperSlide,
    countTo
  },
  data() {
    return {
      externalURL:
        "https://sugar.aipage.com/dashboard/48000e385f081c3849cfec8ff3d4315d", // 设置外部 URL 页面链接
      swiperOptions: {
        loop: false,
        speed: 2000,
        // autoplay: {
        //   delay: 50000000000,
        //   stopOnLastSlide: false,
        //   disableOnInteraction: false
        // },
        // 设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        pagination: {
          el: ".swiper-pagination",
          type: "fraction"
        },
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true //修改swiper的父元素时，自动初始化swiper
      },
      swiperOptions2: {
        loop: true,
        speed: 2000,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        pagination: {
          el: ".swiper-pagination2",
          clickable: true
        },
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true //修改swiper的父元素时，自动初始化swiper
      },
      solutindex1: 2,
      solutindex2: 0,
      solutindex3: 1,
      pageLoaded: false,
      startVal: 0,
      endVal: 2020,
      count1Counted: false,
      count2Counted: false,
      count3Counted: false,
      count4Counted: false,
      newsSlide:[],
      newsList1:null,
      newsList2:null,
      newsList3:null,
    };
  },
  created() {
    // getRequest("https://chanfrer.top/wxGlobe/product/products", function (data) {
    //   console.log(data);
    // })
    let  copy=[...newsData];
    let  copy1=[...newsData];
    this.newsSlide=copy.splice(0,3);
    // this.newsList=copy1.splice(3,3);
    this.newsList1=copy1[1];
    this.newsList2=copy1[4];
    this.newsList3=copy1[5];
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.$nextTick(() => {});
    timer = setInterval(() => {
      this.changeAnimationIndex();
    }, 3000);
    // init wow
    const wow = new WOW({
      boxClass: "wow", //需要执行动画元素的Class
      animateClass: "animated_lightSpeedIn", //animation.css动画的Class
      offset: 0, //距离可视区域多少开始执行动画
      mobile: true, //是否在移动设备执行动画
      live: true //异步加载的内容是否有效
    });
    wow.init();
  },
  destroyed() {
    clearInterval(timer);
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    getAnimationClass(index) {
      const animationClasses = ["ani1", "ani2", "ani3"];
      return animationClasses[index];
    },
    changeAnimationIndex() {
      this.solutindex1 = this.solutindex1 + 1 >= 3 ? 0 : this.solutindex1 + 1;
      this.solutindex2 = this.solutindex2 + 1 >= 3 ? 0 : this.solutindex2 + 1;
      this.solutindex3 = this.solutindex3 + 1 >= 3 ? 0 : this.solutindex3 + 1;
    },
    newsDetail(id){
      this.$router.push({
        name: "newsDetail",
        query: {
          id: id
        }
      });
    },
    handleScroll() {
      const counts = [
        this.$refs.count1,
        this.$refs.count2,
        this.$refs.count3,
        this.$refs.count4
      ];
      counts.forEach(item => {
        const top = item.$el.getBoundingClientRect().top;
        if (top < window.innerHeight) {
          if (!this[`${item.$vnode.data.ref}Counted`]) {
            item.start();
            this[`${item.$vnode.data.ref}Counted`] = true;
          }
        }
      });
    },
  }
};
</script>

<style scoped lang="scss">
.chartIframe {
  width: 100%;
  height: 100vh;
  //height: 9.8rem;
  //padding-top: 1rem;
  position: relative;
  background: #000;
}
.videoCon {
  position: relative;
  height: 100vh;
  .textCon {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.45);
    top: 0;
    left: 0;
    display: flex;
    // justify-content: center;
    align-items: center;
    flex-direction: column;
    color: white;
    font-size: 0.01rem;
    padding-top: 2.4rem;
    .img-con-x-first {
      display: flex;
      font-size: 1.1rem;
      font-family: PingFang SC;
      font-weight: 600;
      line-height: 1.54rem;
      color: #ffffff;
      opacity: 1;
      margin-bottom: 0.3rem;
    }

    .img-con-x-first-x {
      width: 0.99rem;
      height: 1.54rem;
      margin-right: 0.2rem;
      vertical-align: center;
    }

    .img-con-x-second {
      font-size: 0.6rem;
      font-family: PingFang SC;
      font-weight: 200;

      color: #ffffff;
      letter-spacing: 0.36rem;
      opacity: 1;
    }

    .img-con-x-third {
      margin-top: 0.7rem;
      font-weight: bold;
      width: 1.8rem;
      height: 0.6rem;
      background: #fef100;
      opacity: 1;
      border-radius: 0.3rem;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .img-con-x-third-text {
      font-size: 0.16rem;
      font-family: PingFang SC;
      //font-weight: 400;
      line-height: 0.3rem;
      color: #3b5377;
      opacity: 1;
    }
    .focusUs {
      position: absolute;
      bottom: 0.88rem;
      left: 1.8rem;
      font-size: 0.16rem;
      color: #fff;
      img {
        width: 0.14rem;
        height: 0.14rem;
        margin-left: 0.08rem;
      }
    }
  }
}
//.item-box {
//  /*position: relative;*/
//  width: 100%;
//  //height: 100vh;
//  //height: 9.8rem;
//  height: 100%;
//  background-image: url("../../assets/image/index/index_x.png"); /* 使用图像路径或 URL */
//  background-repeat: no-repeat; /* 控制背景图像是否重复 */
//  background-size: cover; /* 控制背景图像的尺寸适应方式 */
//  background-position: center; /* 将背景图像在容器中居中显示 */
//  padding-bottom: 4.25rem;
//}
.item-box1 {
  /*position: relative;*/
  width: 100%;
  // height: 100vh;
  background-image: url("../../assets/image/index/index_x1.png"); /* 使用图像路径或 URL */
  background-repeat: no-repeat; /* 控制背景图像是否重复 */
  background-size: cover; /* 控制背景图像的尺寸适应方式 */
  background-position: center; /* 将背景图像在容器中居中显示 */
  padding-bottom: 2.75rem;
  background-color: black;
}

.item {
  width: 100%;
  // height: 100vh;
  height: 10.8rem;
}

.image {
  max-width: 100%;
  height: auto;
  /*margin-top: -10rem;*/
}

.img-con {
  /*position: absolute;*/
  /*top: 0;*/
  /*left: 0;*/
  color: white;
  font-size: 0.01rem;
  font-weight: bold;
  // text-shadow: 0.02rem 0.02rem 0.04rem rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  /*height: 100%;*/
  .img-con-x-first {
    display: flex;
    font-size: 1.1rem;
    font-family: PingFang SC;
    font-weight: 600;
    line-height: 1.54rem;
    color: #ffffff;
    opacity: 1;
    margin-top: 2.49rem;
  }

  .img-con-x-first-x {
    font-size: 1.3rem;
    font-family: Big Caslon;
    font-weight: 500;
    line-height: 1.56rem;
    color: #ffffff;
    opacity: 1;
    margin-left: 0.21rem;
  }

  .img-con-x-second {
    font-size: 0.6rem;
    font-family: PingFang SC;
    font-weight: 200;
    line-height: 0.84rem;
    color: #ffffff;
    letter-spacing: 0.36rem;
    opacity: 1;
  }

  .img-con-x-third {
    margin-top: 0.8rem;
    width: 1.8rem;
    height: 0.6rem;
    background: #fef100;
    opacity: 1;
    border-radius: 0.3rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .img-con-x-third-text {
    font-size: 0.16rem;
    font-family: PingFang SC;
    //font-weight: 400;
    line-height: 0.3rem;
    color: #3b5377;
    opacity: 1;
  }

  .img-con-x-fourth {
    margin-top: 0.7rem;
    display: flex;
    font-size: 0.3rem;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 0.42rem;
    color: #ffffff;
    letter-spacing: 0.15rem;
    opacity: 1;
  }
}

.item-product {
  /*padding: 0 0.2rem;*/
  /*background: #FFFFFF;*/
  width: 100%;
  // height: 100vh;
  background-image: url("../../assets/image/index/index-product-bg.png"); /* 使用图像路径或 URL */
  background-repeat: no-repeat; /* 控制背景图像是否重复 */
  background-size: cover; /* 控制背景图像的尺寸适应方式 */
  background-position: center; /* 将背景图像在容器中居中显示 */
  color: #ffffff !important;
  background-color: black;
  padding-bottom: 0.8rem;
}

.item-product-title {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.item-product-first-title {
  margin-top: 0.8rem;
  text-stroke: 0.02rem rgba(255, 255, 255, 0.4);
  -webkit-text-stroke: 0.02rem rgba(255, 255, 255, 0.4);
  -o-text-stroke: 0.02rem rgba(255, 255, 255, 0.4);
  -moz-text-stroke: 0.02rem rgba(255, 255, 255, 0.4);
  color: #000;
  font-size: 0.8rem;
  transform: scale(0.5);
  transform-origin: center bottom;
  z-index: 0;
  position: relative;
}

.item-product-second-title {
  font-size: 0.34rem;
  font-family: PingFang SC;
  font-weight: 500;
  //color: #3B5377;
  opacity: 1;
  margin-top: -0.3rem;
  margin-bottom: 0.4rem;
  position: relative;
  z-index: 1;
}

.item-product-first-device {
  height: 3.35rem;
  background: rgba(246, 246, 246, 0.2);
  font-size: 0.16rem;
  font-family: PingFang SC;
  font-weight: 400;
  //color: #3B5377;
  opacity: 1;
  padding-top: 0.28rem;
  padding-left: 0.4rem;
  /*width: calc((100% - 0.6rem)/2);*/
  width: calc((100% - 0.4rem) / 3);
  position: relative;
}

.item-product-first-device-title {
  font-size: 0.24rem;
  font-family: PingFang SC;
  font-weight: 500;
  //color: #3b5377;
  opacity: 1;
  margin-bottom: 0.2rem;
}

.item-product-first-device> ul {
  list-style-type: disc; /* 显示原点 */
}

.item-product-first-device > ul > li {
  /*color: blue; !* 自定义颜色 *!*/
  margin-bottom: 0.19rem;
  margin-left: 0.2rem; /* 为列表项留出空间 */
}
.item-product-three-device-item> ul{
  list-style-type: disc; /* 显示原点 */
}
.item-product-three-device-item> ul > li {
  /*color: blue; !* 自定义颜色 *!*/
  margin-bottom: 0.19rem;
  margin-left: 0.2rem; /* 为列表项留出空间 */
}

.item-product-second-device {
  height: 4.52rem;
  background: rgba(246, 246, 246, 0.2);
  font-size: 0.16rem;
  font-family: PingFang SC;
  font-weight: 400;
  //color: #3b5377;
  padding-top: 0.6rem;
  padding-left: 0.4rem;
  /*width: calc((100% - 1rem) / 5); !*为啥是减1rem*!*/
  width: calc((100% - 0.6rem) / 4);
  position: relative;
}

.item-product-second-device > ul {
  list-style-type: disc; /* 显示原点 */
}

.item-product-second-device > ul > li {
  /*color: blue; !* 自定义颜色 *!*/
  margin-bottom: 0.19rem;
  margin-left: 0.2rem; /* 为列表项留出空间 */
}

.item-product-second-device-title {
  margin-bottom: 0.39rem;
}

//.item-customer {
//  width: 100%;
//  // height: 100vh;
//  background-image: url("../../assets/image/index/index-customer-bg.png"); /* 使用图像路径或 URL */
//  background-repeat: no-repeat; /* 控制背景图像是否重复 */
//  background-size: 100% 100%; /* 控制背景图像的尺寸适应方式 */
//  background-position: center; /* 将背景图像在容器中居中显示 */
//}

.item-news {
  padding-top: 1rem;
  padding-bottom: 1.33rem;
  width: 100%;
  // height: 100vh;
  height: 10.8rem;
  background-image: url("../../assets/image/index/index-new-bg.png"); /* 使用图像路径或 URL */
  background-repeat: no-repeat; /* 控制背景图像是否重复 */
  background-size: 100% 100%; /* 控制背景图像的尺寸适应方式 */
  background-position: center; /* 将背景图像在容器中居中显示 */
}

.item-news-title {
  display: flex;
  /*justify-content: center;*/
  align-items: center;
  flex-direction: column;
}

.item-news-first-title {
  font-weight: 500;
  text-stroke: 0.02rem rgba(255, 255, 255, 0.4);
  -webkit-text-stroke: 0.02rem rgba(255, 255, 255, 0.4);
  -o-text-stroke: 0.02rem rgba(255, 255, 255, 0.4);
  -moz-text-stroke: 0.02rem rgba(255, 255, 255, 0.4);
  color: #000;
  font-size: 0.8rem;
  transform: scale(0.5);
  transform-origin: center bottom;
  z-index: 0;
  position: relative;
}

.item-news-second-title {
  font-size: 0.34rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
  opacity: 1;
  margin-top: -0.35rem;
  position: relative;
  z-index: 1;
}

.item-news-box {
  margin-top: 0.8rem;
  display: flex;
  justify-content: space-around;
}

.item-news-box-left {
  width: 7.12rem;
  margin-right: 0.4rem;
  position: relative;
}

.item-news-box-title {
  width: 6.28rem;
  font-size: 0.2rem;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 0.28rem;
  color: #ffffff;
  opacity: 1;
  margin-top: 0.2rem;

}

.item-news-box-content {
  width: 6.28rem;
  font-size: 0.14rem;
  font-family: PingFang SC;
  font-weight: 300;
  line-height: 0.2rem;
  color: #ffffff;
  opacity: 1;
  margin-top: 0.2rem;
}

.item-news-box-date {
  font-size: 0.14rem;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 0.2rem;
  color: #ffffff;
  opacity: 1;
  margin-top: 0.2rem;
}

.item-news-box-right-news-item {
  display: flex;
  align-items: start;
  justify-content: start;
}

.el-divider--horizontal {
  margin: 0.4rem 0;
}

.item-product-con-first-line {
  padding: 0 0.2rem;
  display: flex;
  /* 	align-items: center; */
  justify-content: space-between;
}

.item-product-con-second-line {
  padding: 0 0.2rem;
  display: flex;
  /* 	align-items: center; */
  justify-content: space-between;
}

.item-about {
  width: 100%;
  // height: 100vh;
  background-image: url("../../assets/image/index/index_about_us.png"); /* 使用图像路径或 URL */
  background-repeat: no-repeat; /* 控制背景图像是否重复 */
  background-size: cover; /* 控制背景图像的尺寸适应方式 */
  background-position: center; /* 将背景图像在容器中居中显示 */
  padding-bottom: 1.97rem;
  background-color: black;
}

.item-about-con {
  padding-left: 1.8rem;
  padding-top: 1.8rem;
}
.item-about-con-title-en {
  font-weight: 500;
  text-stroke: 0.02rem rgba(255, 255, 255, 0.4);
  -webkit-text-stroke: 0.02rem rgba(255, 255, 255, 0.4);
  -o-text-stroke: 0.02rem rgba(255, 255, 255, 0.4);
  -moz-text-stroke: 0.02rem rgba(255, 255, 255, 0.4);
  color: #000;
  font-size: 0.8rem;
  transform: scale(0.5);
  transform-origin: left bottom;
  z-index: 0;
  position: relative;
}
.item-about-con-title-zh {
  font-size: 0.34rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
  opacity: 1;
  margin-left: 0.1rem;
  margin-top: -0.3rem;
  position: relative;
  z-index: 1;
}
.item-about-con-desc {
  font-size: 0.14rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #ffffff;
  opacity: 1;
  margin-top: 0.8rem;
  width: 10.53rem;
}
.item-about-con-desc-num {
  display: flex;
  flex-direction: column;
  margin-right: 1.2rem;
}
.item-about-con-desc-num-item-title {
  font-size: 0.2rem;
  font-family: PingFang SC;
  font-weight: 400;
  //line-height: 0.17rem;
  color: #ffffff;
  opacity: 1;
  margin-bottom: 0.21rem;
}
.item-about-con-desc-num-item-data {
  display: flex;
  align-items: baseline;
}
.item-about-con-desc-num-item-data-num {
  font-size: 0.54rem;
  font-family: DIN Condensed;
  font-weight: bold;
  line-height: 0.3rem;
  color: #fef100;
  opacity: 1;
}
.item-about-con-desc-num-item-data-icon {
  font-size: 0.3rem;
  font-family: DIN Condensed;
  font-weight: bold;
  line-height: 0.3rem;
  color: #ffffff;
  opacity: 1;
  margin-left: 0.1rem;
}
.item-about-con-sol {
  width: 8.02rem;
  font-size: 0.2rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #ffffff;
  opacity: 1;
  margin-top: 0.8rem;
}
.item-about-con-more {
  width: 1.6rem;
  height: 0.48rem;
  border: 0.01rem solid #fef100;
  opacity: 1;
  border-radius: 0.3rem;
  color: #fef100;
  font-size: 0.16rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0.8rem;
}
.item-product-first-detail-img {
  width: 0.6rem;
  height: 0.6rem;
  position: absolute;
  left: 0.4rem;
  bottom: 0.28rem;
}
.item-product-first-device-img {
  position: absolute;
}
.item-product-second-detail-img {
  width: 0.6rem;
  height: 0.6rem;
  position: absolute;
  left: 0.4rem;
  bottom: 0.55rem;
}
.item-partner {
  padding: 2.27rem 0 3.1rem 1.83rem;
  /*background-color: black;*/
  width: 100%;
  // height: 100vh;
  background-image: url("../../assets/image/index/index-partner-bg.png"); /* 使用图像路径或 URL */
  background-repeat: no-repeat; /* 控制背景图像是否重复 */
  background-size: cover; /* 控制背景图像的尺寸适应方式 */
  background-position: center; /* 将背景图像在容器中居中显示 */
  /*height: 10.80rem;*/
}
.item-partner-first-title {
  font-size: 0.4rem;
  font-weight: 500;
  color: white;
  -webkit-text-stroke: 2 #ffffff;
  text-stroke: 2 #ffffff;
  opacity: 0.4;
}
.item-partner-second-title {
  font-size: 0.34rem;
  font-weight: 500;
  color: #ffffff;
  opacity: 1;
  margin-top: -0.3rem;
}
.item-partner-num {
  display: flex;
  justify-content: start;
  margin-top: 1.07rem;
}
.item-partner-num-data {
  font-size: 1.26rem;
  font-family: Skia, Skia;
  font-weight: bold;
  color: #fef100;
  text-shadow: 0.1rem 0.05rem 0.04rem rgba(254, 241, 0, 0.4);
  letter-spacing: 0.07rem;
}
.item-partner-num-icon {
  font-size: 0.66rem;
  font-family: Skia;
  font-weight: bold;
  color: #fef100;
}
.item-partner-sou {
  font-size: 0.3rem;
  font-weight: 500;
  color: #ffffff;
  opacity: 1;
  margin-top: 0.53rem;
}
.item-partner-desc {
  margin-top: 0.4rem;
  font-size: 0.14rem;
  font-weight: 400;
  line-height: 0.4rem;
  color: #ffffff;
  opacity: 1;
  width: 6.63rem;
}
.item-partner-more {
  width: 1.6rem;
  height: 0.48rem;
  border-radius: 0.3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 1;
  border: 0.01rem solid #fef100;
  font-size: 0.16rem;
  /*font-family: PingFang SC, PingFang SC;*/
  font-weight: 400;
  margin-top: 0.8rem;
  color: #fef100;

  /*-webkit-background-clip: text;*/
  /*-webkit-text-fill-color: transparent;*/
}

.item-solution {
  padding: 1.35rem 1.8rem 2.2rem;
  background-color: black;
  position: relative;
  display: flex;
  background-image: url("../../assets/image/index/index-solution-bg.png"); /* 使用图像路径或 URL */
  background-repeat: no-repeat; /* 控制背景图像是否重复 */
  background-size: cover; /* 控制背景图像的尺寸适应方式 */
  background-position: center; /* 将背景图像在容器中居中显示 */
  // height: 100vh;
  /*height: 10.80rem;*/
  .solutionBrief {
    width: 6rem;
    padding-right: 1.2rem;
    .item-solution-first-title {
      font-size: 0.4rem;
      text-stroke: 0.02rem rgba(255, 255, 255, 0.4);
      -webkit-text-stroke: 0.02rem rgba(255, 255, 255, 0.4);
      -o-text-stroke: 0.02rem rgba(255, 255, 255, 0.4);
      -moz-text-stroke: 0.02rem rgba(255, 255, 255, 0.4);
      font-size: 0.8rem;
      transform: scale(0.5);
      transform-origin: left bottom;
      z-index: 0;
      position: relative;
    }
    .item-solution-second-title {
      font-size: 0.34rem;
      font-weight: 500;
      color: #ffffff;
      margin-top: -0.3rem;
      position: relative;
      z-index: 1;
    }
    .item-solution-desc {
      margin-top: 0.8rem;
      font-size: 0.14rem;
      font-weight: 400;
      color: #ffffff;
      line-height: 0.4rem;
      -webkit-background-clip: text;
    }
    .item-solution-more {
      width: 1.6rem;
      height: 0.48rem;
      border-radius: 0.3rem;
      display: flex;
      justify-content: center;
      align-items: center;
      opacity: 1;
      border: 0.01rem solid #fef100;
      font-size: 0.16rem;
      /*font-family: PingFang SC, PingFang SC;*/
      font-weight: 400;
      margin-top: 0.8rem;
      color: #fef100;
    }
  }
  .solutionList {
    position: relative;
    flex: 1;
    height: 7.24rem;
    .solutionItem {
      width: 3.52rem;
      height: 7.24rem;
      border-radius: 0.2rem;
      padding-top: 5.6rem;
      overflow: hidden;
      background-image: url("../../assets/image/index/solution-wifi.png");
      background-position: center center;
      background-size: cover;
      background-repeat: no-repeat;
      position: absolute;
      top: 0;
      left: 0;
      transform: scale(1);
      transform-origin: center;

      .info {
        background: rgba(255, 255, 255, 0.39);
        height: 100%;
        padding: 0.2rem 0.05rem 0 0.2rem;
        color: #ffffff;
        font-size: 0.14rem;
        .title {
          font-size: 0.34rem;
          margin-bottom: 0.15rem;
          font-weight: 500;
        }
        .areablock {
          display: flex;
          flex-wrap: wrap;
          > div {
            height: 0.27rem;
            line-height: 0.27rem;
            background: rgba(255, 255, 255, 0.39);
            border-radius: 0.14rem;
            padding: 0 0.2rem;
            margin-right: 0.1rem;
            margin-bottom: 0.1rem;
          }
        }
      }

      &:nth-child(2) {
        transform: scale(0.86);
        left: 3.6rem;
        background-image: url("../../assets/image/index/solution-school.png");
      }
      &:nth-child(3) {
        transform: scale(0.74);
        left: 6.75rem;
        background-image: url("../../assets/image/index/solution-factory.png");
        .info {
          background: rgba(0, 0, 0, 0.39);
        }
      }

      &.ani1 {
        animation: soluteAnimation1 600ms ease-out 0s 1 forwards;
      }

      &.ani2 {
        animation: soluteAnimation2 600ms ease-out 0s 1 forwards;
      }

      &.ani3 {
        animation: soluteAnimation3 600ms ease-out 0s 1 forwards;
      }
    }
  }
}

/* 首屏轮播样式修改 */
.section1_swiper {
  position: relative;
  .circle-foot {
    z-index: 20;
    position: absolute;
    width: 0.18rem;
    height: 0.26rem;
    background: transparent;
    left: 50%;
    margin-left: -0.09rem;
    bottom: 0.88rem;
    border: 1px solid #fff;
    border-radius: 38%;
    &:before {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      width: 0rem;
      height: 0.08rem;
      border: 0.01rem dashed rgba(255, 255, 255, 0.5);
      transform: translate(-50%, -50%);
    }
  }
  .swiper-button-prev,
  .swiper-button-next {
    width: 0.48rem;
    height: 0.48rem;
    background: rgba(255, 255, 255, 0.3);
    color: #fff;
    border-radius: 40%;
    left: auto;
    top: auto;
    bottom: 0.88rem;
    &::after {
      font-size: 0.18rem;
    }
  }
  .swiper-button-prev {
    right: 2.48rem;
  }
  .swiper-button-next {
    right: 1.8rem;
  }
  .swiper-pagination {
    left: auto;
    top: auto;
    bottom: 0.88rem;
    right: 3.16rem;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.5);
    width: auto;
    font-size: 0.2rem;
  }
}
.item-product-three-device{
  height: 4.52rem !important;
  padding-top: 0.6rem!important;
  .item-product-first-device-title{
    margin-bottom: 0.4rem !important;
  }
  .item-product-first-detail-img{
    bottom: 0.55rem;
  }
}
</style>

<style>
/* 解决方案动画定义 */
@keyframes soluteAnimation1 {
  0% {
    left: 0;
    transform: scale(1);
  }

  100% {
    left: 3.6rem;
    transform: scale(0.86);
  }
}
@keyframes soluteAnimation2 {
  0% {
    left: 3.6rem;
    transform: scale(0.86);
  }

  100% {
    left: 6.74rem;
    transform: scale(0.74);
  }
}
@keyframes soluteAnimation3 {
  0% {
    left: 6.74rem;
    transform: scale(0.74);
  }

  100% {
    left: 0;
    transform: scale(1);
  }
}

/* 首屏轮播 */
.section1_swiper .swiper-pagination-current {
  color: #fff;
  font-size: 0.3rem;
  font-weight: 700;
}
/* news轮播 */
.swiper-pagination2 {
  bottom: 0.37rem;
  position: absolute;
  text-align: right;
  padding-right: 0.4rem;
  z-index: 9;
}
.swiper-pagination2 .swiper-pagination-bullet {
  background: #707070;
  opacity: 1;
}
.swiper-pagination2 .swiper-pagination-bullet-active {
  opacity: 1;
  background: #fef100;
}
/* fullpage插件样式修改 */
#fp-nav {
  margin-top: 0 !important;
}
#fp-nav ul li,
.fp-slidesNav ul li {
  width: 0.24rem;
  height: 0.24rem;
  margin: 0.06rem;
}

#fp-nav ul li a span,
.fp-slidesNav ul li a span {
  height: 0.08rem;
  width: 0.08rem;
  background: transparent;
  margin: -0.04rem 0 0 -0.04rem;
  border-radius: 50%;
  border: 0.01rem solid #ffffff;
}

#fp-nav ul li a.active span,
#fp-nav ul li:hover a.active span,
.fp-slidesNav ul li a.active span,
.fp-slidesNav ul li:hover a.active span {
  height: 0.08rem;
  width: 0.08rem;
  border-radius: 50%;
  margin: -0.04rem 0 0 -0.04rem;
  background: #fef100;
  border: 0.01rem solid #fef100;
}

#fp-nav ul li a {
  width: 0.24rem;
  height: 0.24rem;
  border: 0.01rem solid transparent;
  border-radius: 50%;
}
#fp-nav ul li a.active {
  border: 0.01rem solid #fef100;
}
.brief {
  /*line-height: 0.3rem;*/
  width: 100%;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* 设置最大显示行数 */
  -webkit-box-orient: vertical;
}

@media (max-width: 1199px) {
  .chartIframe,
  .videoCon{
    height: 10.8rem !important;
  }
  .videoCon{
    background-color: #000;
  }
}


</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue